export const egRegions = {
  EUR :10,
  ASI :10,
  CAN :-1,
  USA :-1,
  SUD :-1,
  FRO :-1,
  PLA :-1,
  LOC :-1,
  SUDLH:-1,
  CAM:-1,
  CAR:-1
}
